import { Type } from "class-transformer";
import { PersonSummaryOutDTO } from "../person/person-summary.out.dto";

export class PersonInShopOutDTO {
  role?: string;

  @Type(() => PersonSummaryOutDTO)
  person!: PersonSummaryOutDTO;
}
